import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { SoProductionResponseModel } from '@gtpl/shared-models/sale-management';
import { Injectable } from '@nestjs/common';
import { SoProductionAdapter } from '../dto/so-production.adapter';
import { SoProductionDTO } from '../dto/so-production.dto';
import { SoProduction } from '../entities/so-production.entity';
import { SoProductionRepository } from '../repository/so-production.repository';

@Injectable()
export class SoProductionService {
    constructor(private soProductionRepo:SoProductionRepository, private soProductionAdapter : SoProductionAdapter){}

    async createSoProduction(soProductionDto: SoProductionDTO, isUpdate): Promise<SoProductionResponseModel> {
        // console.log(statesDto);
        
        try {
          
          const convertedSoProductionEntity: SoProduction = this.soProductionAdapter.convertDtoToEntity(soProductionDto);
          const savedSoProductionEntity: SoProduction = await this.soProductionRepo.save(
            convertedSoProductionEntity
          );
          const savedSoProductionDto: SoProductionDTO = this.soProductionAdapter.convertEntityToDto(convertedSoProductionEntity);
            // console.log(savedStateDto);
          if (savedSoProductionDto) { 
           // generating resposnse
           const response = new SoProductionResponseModel(true,1,isUpdate? 'SoProduction Updated Successfully': 'SoProduction Created Successfully');
           return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'SoProduction saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          return error;
        }
      }  
}
